import React from "react";
import Footer from "../../components/Layout/Footer";
import ScrollToTop from "../../components/Common/ScrollTop";
import SiteBreadcrumb from "../../components/Common/Breadcumb";
import AboutMain from "./AboutMain";
import CounterStyleThree from "../../components/Elements/Counter/CounterStyleThree";

const About = () => {
  return (
    <React.Fragment>
      <>
        <main>
          <SiteBreadcrumb
            pageTitle="About Us"
            titleClass="page-title"
            pageName="About"
          />

          <AboutMain />

          <ScrollToTop />
        </main>
        <CounterStyleThree />
        <Footer />
      </>
    </React.Fragment>
  );
};

export default About;
